<template>
  
  <div>

    <div class="ui grid">

      <div class="sixteen wide field m-t-15">
        <button class="ui mini basic button" @click="setRowsSelection(true)">
          <i class="check double blue icon"></i> Selecionar todos
        </button>
        <button class="ui mini basic button m-l-10" @click="setRowsSelection(false)">
          <i class="times red icon"></i> Remover seleção
        </button>
      </div>

      <div class="sixteen wide column">
        <table class="ui celled selectable tablet stackable table">
          <thead v-if="$isDesktop">
            <tr>
              <th>Número</th>        
              <th>Status</th>
              <th>Tipo</th>            
              <th>Fornecedor</th>
              <th>Vencimento</th>
              <th>Valor Título</th>
              <th>Valor Baixado</th>
              <th>Saldo</th>
              <th style="min-width: 250px !important;">Ação</th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="(payable, index) in payables" @click="onRowClick($event, index)">
              <td>
                <strong class="mobile-only">Número: </strong> 
                <i class="circle blue icon m-r-10" :class="{ outline: !payable.selected, check: payable.selected }"></i>
                {{ payable.id }}
              </td>
              <td>
                <strong class="mobile-only">Status: </strong> 
                <span v-html="payable.statusData.label"></span>
              </td>
              <td>
                <strong class="mobile-only">Tipo: </strong>
                <span v-html="payable.typeData.label"></span>
              </td>            
              <td>
                <strong class="mobile-only">Fornecedor: </strong> {{ payable.supplier.shortName }}
              </td>
              <td :class="{ negative: payable.isExpired }">
                <strong class="mobile-only">Vencimento: </strong> {{ $formatDate(payable.realDueDate) }}
              </td>
              <td>
                <strong class="mobile-only">Valor Título: </strong> {{ $formatCurrency(payable.value) }}
              </td>
              <td>
                <strong class="mobile-only">Valor Baixado: </strong> 
                {{ $formatCurrency(payable.value - payable.balance) }}
              </td>
              <td>
                <strong class="mobile-only">Saldo: </strong> {{ $formatCurrency(payable.balance) }}
              </td>
              <td class="clickable" @click="onActionClick($event, index)">
                <div class="ui pointing dropdown text payables-grid-dropdown" 
                  :class="{ blue: payable.selected, grey: !payable.selected }">
                  <span>{{ payable.actionLabel }}</span>
                  <i class="caret down icon" style="margin-left: 3px;"></i> 
                  <div class="menu">
                    <div v-if="payable.balance > 0" class="item" @click="onSetAction($event, index, 'full_settle')">
                      <i class="check circle green icon"></i>
                      Baixar saldo restante
                    </div>
                    <div v-if="payable.balance > 0" class="item" @click="onSetAction($event, index, 'partial_settle')">
                      <i class="edit blue icon"></i>
                      Definir detalhes da baixa
                    </div>
                    <div v-if="payable.balance < payable.value" class="item" @click="onSetAction($event, index, 'undo')">
                      <i class="undo red icon"></i>
                      Estornar última baixa
                    </div>
                    <div class="item" @click="onSetAction($event, index, 'nothing')">
                      <i class="ban grey icon"></i>
                      Nenhuma ação
                    </div>
                  </div>
                </div>
              </td>
            </tr>                
          </tbody>
        </table>
      </div>

    </div>

    <value-modal ref="valueModal" :disableCompensation="true" @onConfirm="onConfirmValue" />

  </div>

</template>

<script>

  import ValueModal from "./value-modal"

  export default {
    
    name: "PayablesSettlesGrid",

    data() {
      return {
        payables: [],
      }
    },

    components: {
      ValueModal,
    },
    
    methods: {

      setPayables(payables) {
        
        this.payables = payables.slice()

        payables.forEach((payable) => {
          payable.action = "nothing"
          this.setActionData(payable)
        })

        setTimeout(() => this.loadGridDropdowns(), 1000)
      },

      loadGridDropdowns() {
        $(".payables-grid-dropdown").dropdown()
      },

      onRowClick($event, index) {

        $event.stopPropagation()

        let payables = this.payables.slice()
        let payable = payables[index]

        payable.selected = !payable.selected

        if (payable.selected) {
          payable.action = "full_settle"
        } else {
          payable.action = "nothing"
        }

        this.setActionData(payable)

        this.payables = payables.slice()
      },

      setRowsSelection(selected) {

        let payables = this.payables.slice()

        payables.forEach((payable) => {
          
          payable.selected = selected
          
          if (selected && payable.action == "nothing") {
            payable.action = "full_settle"
          } else if (!selected) {
            payable.action = "nothing"
          }

          this.setActionData(payable)
        })

        this.payables = payables.slice()
      },

      onActionClick($event, index) {        
        $event.stopPropagation()
      },

      onSetAction($event, index, action) {

        $event.stopPropagation()

        $(".payables-grid-dropdown").dropdown("hide")

        let payables = this.payables.slice()

        payables[index].action = action

        if (action == "partial_settle")
          return this.$refs.valueModal.create(payables[index])
        
        this.setActionData(payables[index])

        this.payables = payables.slice()  
      },

      setActionData(payable) {

        let label =  ""
        let selected = true
        let action = payable.action

        if (action == "full_settle" && !payable.balance)
          action = "nothing"

        if (action == "full_settle") {
          
          label = `Baixar o saldo de R$ ${this.$formatCurrency(payable.balance)}`

        } else if (action == "compensate") {

          label = "Compensar..."
          
        } else if (action == "undo") {

          label = "Estornar última baixa"
          
        } else if (action == "nothing") {  

          selected = false
          label = "Nenhuma ação selecionada"
        }

        if (label) {
          payable.actionLabel = label          
          payable.selected = selected
        }  

        return label
      },

      onConfirmValue(data) {

        const { payable, value, date, refDate } = data

        let payables = this.payables.slice()
        let target = this.payables.find((el) => el.id == payable.id)

        payables.forEach((el) => {
          if (el.id == payable.id) {
            el.settleDate = date
            el.settleRefDate = refDate
            el.settleValue = value
            el.action = "partial_settle"
            el.actionLabel = `Baixar R$ ${this.$formatCurrency(value)}`
            el.selected = true
          }
        })

        this.payables = payables.slice()
      },

      getSettles() {

        let settles = []

        this.payables.forEach((payable) => {

          if (!payable.selected)
            return

          let { id, action, settleDate, settleRefDate, settleValue, balance } = payable
          
          if (action == "full_settle")
            settleValue = balance

          settles.push({ 
            payableId: id, 
            action, 
            date: settleDate, 
            refDate: settleRefDate,
            value: settleValue ,
          })
        })

        return settles
      },
    },
  }

</script>